import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccountSetting = _resolveComponent("AccountSetting")!
  const _component_AccountSettingsSection = _resolveComponent("AccountSettingsSection")!

  return (_openBlock(), _createBlock(_component_AccountSettingsSection, {
    loading: _ctx.loading,
    title: "Account information",
    isEditable: _ctx.customer.type === _ctx.UserType.Customer,
    onSubmit: _ctx.submit,
    ref: "settingsSectionRef"
  }, {
    default: _withCtx(({open}) => [
      _createVNode(_component_AccountSetting, {
        disabled: !open,
        icon: "account/mail",
        errors: _ctx.v$.email.$errors,
        modelValue: _ctx.v$.email.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.email.$model) = $event)),
        type: "email",
        name: "email",
        placeholder: "Email"
      }, null, 8, ["disabled", "errors", "modelValue"]),
      _createVNode(_component_AccountSetting, {
        disabled: !open,
        icon: "account/phone",
        errors: _ctx.v$.phone.$errors,
        modelValue: _ctx.v$.phone.$model,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.phone.$model) = $event)),
        name: "phone",
        placeholder: "Telephone"
      }, null, 8, ["disabled", "errors", "modelValue"])
    ]),
    _: 1
  }, 8, ["loading", "isEditable", "onSubmit"]))
}